(function () {
  var moneyFormat =
    (window.theme && theme.moneyFormat) ||
    (window.Shopify && Shopify.money_format) ||
    'Rs. {{amount}}';

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, moneyFormat);
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    var value = (Number(cents) / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(cents) / 100)));
  }

  function cartAddUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base.indexOf('.js') === -1 ? base + '.js' : base;
  }

  function drawer() {
    return document.querySelector('[data-nb-drawer]');
  }

  function updateCounts(count) {
    var n = Number(count) || 0;
    document.querySelectorAll('[data-nb-cart-count], .js-cart-count, .nb-header__count, .nb-bottom-bar__count').forEach(function (el) {
      el.textContent = String(n);
      if (el.classList.contains('nb-bottom-bar__count')) {
        if (n > 0) {
          el.hidden = false;
          el.removeAttribute('hidden');
        } else {
          el.hidden = true;
        }
        return;
      }
      if (el.classList.contains('nb-header__count') || el.classList.contains('js-cart-count')) {
        if (n > 0) {
          el.hidden = false;
          el.style.display = '';
        } else if (el.classList.contains('nb-header__count') || el.closest('.nb-header__actions')) {
          el.style.display = 'none';
        }
      }
    });
  }

  function itemHtml(item, line) {
    var img = item.image
      ? '<img src="' + String(item.image).replace(/&width=\d+/g, '') + (String(item.image).indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="80" height="100" loading="lazy">'
      : '';
    var variant =
      item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="nb-drawer__variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';
    return (
      '<li class="nb-drawer__item" data-line="' +
      line +
      '" data-key="' +
      escapeHtml(item.key) +
      '">' +
      '<a class="nb-drawer__thumb" href="' +
      escapeHtml(item.url) +
      '">' +
      img +
      '</a>' +
      '<div class="nb-drawer__meta">' +
      '<a href="' +
      escapeHtml(item.url) +
      '" class="nb-drawer__name">' +
      escapeHtml(item.product_title || item.title) +
      '</a>' +
      variant +
      '<p class="nb-drawer__price">' +
      formatMoney(item.final_line_price) +
      '</p>' +
      '<div class="nb-drawer__row">' +
      '<div class="nb-drawer__qty">' +
      '<button type="button" data-nb-line-minus aria-label="Decrease quantity">−</button>' +
      '<input type="text" inputmode="numeric" value="' +
      item.quantity +
      '" data-nb-line-qty aria-label="Quantity" readonly>' +
      '<button type="button" data-nb-line-plus aria-label="Increase quantity">+</button>' +
      '</div>' +
      '<button type="button" class="nb-drawer__remove" data-nb-line-remove>Remove</button>' +
      '</div></div></li>'
    );
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderCart(cart) {
    var root = drawer();
    if (!root) return;
    var body = root.querySelector('[data-nb-drawer-items]');
    var footer = root.querySelector('[data-nb-drawer-footer]');
    var total = root.querySelector('[data-nb-cart-total]');
    updateCounts(cart.item_count);

    if (!cart.item_count) {
      if (body) {
        body.innerHTML =
          '<div class="nb-drawer__empty"><p>Your bag is empty</p>' +
          '<a href="/collections/all" class="nb-btn nb-btn--outline">Continue shopping</a></div>';
      }
      if (footer) footer.hidden = true;
      if (total) total.textContent = formatMoney(0);
      return;
    }

    var html = '<ul class="nb-drawer__list">';
    cart.items.forEach(function (item, i) {
      html += itemHtml(item, i + 1);
    });
    html += '</ul>';
    if (body) body.innerHTML = html;
    if (footer) footer.hidden = false;
    if (total) total.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }

  function openDrawer() {
    var root = drawer();
    if (!root) {
      window.location.href = (window.routes && routes.cart_url) || '/cart';
      return;
    }
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nb-drawer-open');
    fetchCart()
      .then(renderCart)
      .catch(function () {});
  }

  function closeDrawer() {
    var root = drawer();
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nb-drawer-open');
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ line: line, quantity: quantity }),
    }).then(function (r) {
      if (!r.ok) throw new Error('change');
      return r.json();
    });
  }

  function isComingSoonVariantId(id) {
    if (!id) return false;
    var sid = String(id);
    var match = false;
    document.querySelectorAll('[data-nb-pill][data-coming-soon="true"]').forEach(function (pill) {
      if (String(pill.getAttribute('data-variant-id') || '') === sid) match = true;
    });
    if (match) return true;
    // Fallback: block known Coming Soon sizes even if markup is missing
    var sizePill = document.querySelector('[data-nb-pill][data-variant-id="' + sid + '"]');
    if (sizePill) {
      var sz = String(sizePill.getAttribute('data-size') || '')
        .toLowerCase()
        .replace(/\s+/g, '');
      if (sz === '50ml' || sz === '100ml') return true;
    }
    return false;
  }

  function addToCart(id, quantity) {
    if (isComingSoonVariantId(id)) {
      return Promise.reject(new Error('This size is Coming Soon and cannot be ordered yet.'));
    }
    var body = new URLSearchParams();
    body.set('id', String(id));
    body.set('quantity', String(quantity));
    return fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: body.toString(),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var msg = (data && (data.description || data.message)) || 'Could not add to bag';
          throw new Error(msg);
        }
        return data;
      });
    });
  }

  function moneyFromDataset(el) {
    return el.getAttribute('data-price') || '';
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-nb-bound') === '1') return;
    root.setAttribute('data-nb-bound', '1');

    var form = root.querySelector('[data-nb-add-form]') || (root.matches('[data-nb-add-form]') ? root : null);
    if (!form) return;

    var input = root.querySelector('[data-nb-variant-input]') || form.querySelector('[name="id"]');
    var priceEls = root.querySelectorAll('[data-nb-price]');
    var compareEl = root.querySelector('[data-nb-compare]');
    var sizeNoteEl = root.querySelector('[data-nb-size-note]');
    var priceNoteEl = root.querySelector('[data-nb-price-note], .nb-pdp__price-note');
    var pills = root.querySelectorAll('[data-nb-pill]');
    var qtyInput = form.querySelector('[data-nb-qty-input], [name="quantity"]');
    var qtyMinus = root.querySelector('[data-nb-qty-minus]');
    var qtyPlus = root.querySelector('[data-nb-qty-plus]');
    var gallery = root.querySelector('[data-nb-gallery]');
    var heroImg = root.querySelector('[data-nb-gallery-hero]');
    var thumbs = root.querySelectorAll('[data-nb-thumb]');
    var prevBtn = root.querySelector('[data-nb-gallery-prev]');
    var nextBtn = root.querySelector('[data-nb-gallery-next]');
    var galleryTimer = null;
    var galleryPaused = false;
    var heroFadeTimer = null;

    function normalizeSize(size) {
      var s = (size || '').toLowerCase().trim().replace(/\s+/g, '');
      if (s === '15ml') return '18ml';
      return s;
    }

    function sizeLabelFromPill(pill) {
      if (!pill) return '';
      return (
        pill.getAttribute('data-size-label') ||
        (pill.textContent || '').replace(/\s+/g, ' ').trim() ||
        pill.getAttribute('data-size') ||
        ''
      );
    }

    function syncSizeNote(pill) {
      var sizeText = sizeLabelFromPill(pill);
      if (!sizeText) return;
      root.querySelectorAll('[data-nb-size-note], [data-nb-bottle-size]').forEach(function (el) {
        el.textContent = sizeText;
      });
      sizeNoteEl = root.querySelector('[data-nb-size-note]');
      if (priceNoteEl && !root.querySelector('[data-nb-size-note]')) {
        priceNoteEl.innerHTML = 'incl. of all taxes · <span data-nb-size-note>' + sizeText + '</span>';
        sizeNoteEl = priceNoteEl.querySelector('[data-nb-size-note]');
      } else if (priceNoteEl && sizeNoteEl) {
        // keep surrounding "incl. of all taxes · " text intact
        sizeNoteEl.textContent = sizeText;
      }
      syncWhatsAppLink(sizeText);
    }

    function syncWhatsAppLink(sizeText) {
      var wa = root.querySelector('[data-nb-wa]');
      if (!wa) return;
      var phone = wa.getAttribute('data-nb-wa-phone') || '917090707023';
      var title = wa.getAttribute('data-nb-wa-title') || '';
      var url = wa.getAttribute('data-nb-wa-url') || '';
      var text = 'Hi NIBHAS, I would like to enquire about ' + title;
      if (sizeText) text += ' (' + sizeText + ')';
      text += '. ' + url;
      wa.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(text);
    }

    function visibleThumbs() {
      return Array.prototype.filter.call(thumbs, function (thumb) {
        return !thumb.hidden;
      });
    }

    function syncGalleryNav() {
      var list = visibleThumbs();
      var show = list.length > 1;
      if (prevBtn) prevBtn.hidden = !show;
      if (nextBtn) nextBtn.hidden = !show;
    }

    function activeThumbIndex(list) {
      var activeIndex = -1;
      list.forEach(function (thumb, i) {
        if (thumb.classList.contains('is-active')) activeIndex = i;
      });
      if (activeIndex < 0) activeIndex = 0;
      return activeIndex;
    }

    function stepGallery(delta) {
      var list = visibleThumbs();
      if (list.length < 2) return;
      var next = list[(activeThumbIndex(list) + delta + list.length) % list.length];
      setHeroFromThumb(next, false);
      startGalleryAuto();
    }

    function setHeroFromThumb(thumb, fromAuto) {
      if (!heroImg || !thumb) return;
      var nextFull = thumb.getAttribute('data-full') || '';
      if (heroImg.getAttribute('data-full') === nextFull && fromAuto) return;
      if (heroFadeTimer) {
        window.clearTimeout(heroFadeTimer);
        heroFadeTimer = null;
      }
      heroImg.classList.add('is-fading');
      heroFadeTimer = window.setTimeout(function () {
        heroImg.src = nextFull;
        var srcset = thumb.getAttribute('data-srcset');
        if (srcset) heroImg.srcset = srcset;
        heroImg.alt = thumb.getAttribute('data-alt') || '';
        heroImg.setAttribute('data-full', nextFull);
        heroImg.classList.remove('is-fading');
        heroFadeTimer = null;
      }, fromAuto ? 180 : 60);
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    }

    function setHeroFromUrl(url, srcset, alt) {
      if (!heroImg || !url) return;
      if (heroFadeTimer) {
        window.clearTimeout(heroFadeTimer);
        heroFadeTimer = null;
      }
      heroImg.classList.add('is-fading');
      heroFadeTimer = window.setTimeout(function () {
        heroImg.src = url;
        if (srcset) heroImg.srcset = srcset;
        if (alt) heroImg.alt = alt;
        heroImg.setAttribute('data-full', url);
        heroImg.classList.remove('is-fading');
        heroFadeTimer = null;
      }, 60);
    }

    function stopGalleryAuto() {
      if (galleryTimer) {
        window.clearInterval(galleryTimer);
        galleryTimer = null;
      }
    }

    function startGalleryAuto() {
      stopGalleryAuto();
      syncGalleryNav();
      if (!gallery || visibleThumbs().length < 2) return;
      galleryTimer = window.setInterval(function () {
        if (galleryPaused) return;
        var list = visibleThumbs();
        if (list.length < 2) return;
        var next = list[(activeThumbIndex(list) + 1) % list.length];
        setHeroFromThumb(next, true);
      }, 3500);
    }

    function filterGallery(size) {
      if (!gallery || !thumbs.length) return;
      var norm = normalizeSize(size);
      var firstSized = null;
      var firstCommon = null;
      thumbs.forEach(function (thumb) {
        var thumbSize = normalizeSize(thumb.getAttribute('data-nb-size') || 'common');
        var show = thumbSize === 'common' || !norm || thumbSize === norm;
        thumb.hidden = !show;
        if (show && thumbSize === norm && !firstSized) firstSized = thumb;
        if (show && thumbSize === 'common' && !firstCommon) firstCommon = thumb;
      });
      var pick = firstSized || firstCommon;
      if (pick) setHeroFromThumb(pick, false);
      startGalleryAuto();
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setHeroFromThumb(thumb, false);
        startGalleryAuto();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        stepGallery(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        stepGallery(1);
      });
    }

    if (gallery) {
      gallery.addEventListener('mouseenter', function () {
        galleryPaused = true;
      });
      gallery.addEventListener('mouseleave', function () {
        galleryPaused = false;
      });
      gallery.addEventListener('focusin', function () {
        galleryPaused = true;
      });
      gallery.addEventListener('focusout', function () {
        galleryPaused = false;
      });
      gallery.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          stepGallery(-1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          stepGallery(1);
        }
      });
      if (!gallery.hasAttribute('tabindex')) gallery.setAttribute('tabindex', '0');
      startGalleryAuto();
    }

    function syncComingSoonUi(pill) {
      var isSoon = !!(pill && pill.getAttribute('data-coming-soon') === 'true');
      var soonTag = root.querySelector('[data-nb-soon-tag]');
      if (soonTag) {
        if (isSoon) soonTag.removeAttribute('hidden');
        else soonTag.setAttribute('hidden', '');
      }
      var btn = form.querySelector('[data-nb-atc]') || form.querySelector('button[type="submit"]');
      if (!btn) return;
      var label = btn.querySelector('[data-nb-atc-label]') || btn.querySelector('span');
      if (isSoon) {
        btn.disabled = true;
        if (label) label.textContent = 'Coming Soon';
        return;
      }
      var available = !pill || !pill.disabled;
      btn.disabled = !available;
      if (label) {
        var price = moneyFromDataset(pill);
        if (btn.classList.contains('nb-pdp__atc')) {
          label.innerHTML = available
            ? 'Add to Bag · <span data-nb-price>' + price + '</span>'
            : 'Sold Out';
        } else {
          label.textContent = available ? 'Add to Cart' : 'Sold Out';
        }
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        pills.forEach(function (p) {
          p.classList.remove('is-active');
        });
        pill.classList.add('is-active');
        if (input) input.value = pill.getAttribute('data-variant-id');
        var nextPrice = moneyFromDataset(pill);
        priceEls.forEach(function (priceEl) {
          priceEl.textContent = nextPrice;
        });
        syncSizeNote(pill);
        var compare = pill.getAttribute('data-compare') || '';
        if (compareEl) {
          if (compare) {
            compareEl.textContent = compare;
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        syncComingSoonUi(pill);
        filterGallery(pill.getAttribute('data-size') || '');

        var cardMedia = root.querySelector('[data-nb-card-media]');
        var imgUrl = pill.getAttribute('data-image');
        if (cardMedia && imgUrl) {
          cardMedia.src = imgUrl;
          var srcset = pill.getAttribute('data-image-srcset');
          if (srcset) cardMedia.srcset = srcset;
          var alt = pill.getAttribute('data-image-alt');
          if (alt) cardMedia.alt = alt;
        } else if (imgUrl && heroImg) {
          setHeroFromUrl(
            imgUrl,
            pill.getAttribute('data-image-srcset') || '',
            pill.getAttribute('data-image-alt') || ''
          );
        }

        var mediaLink = root.querySelector('.nb-card__media');
        var titleLink = root.querySelector('.nb-card__title a');
        var vid = pill.getAttribute('data-variant-id');
        if (vid && mediaLink && mediaLink.href) {
          try {
            var u = new URL(mediaLink.href, window.location.origin);
            u.searchParams.set('variant', vid);
            mediaLink.href = u.pathname + u.search;
            if (titleLink) titleLink.href = mediaLink.href;
          } catch (err) {}
        }
      });
    });

    // Prefer URL/card size (incl. 50ml/100ml Coming Soon for display); fall back to 18ml.
    var preferred = '';
    try {
      preferred = new URLSearchParams(window.location.search).get('size') || '';
    } catch (err) {
      preferred = '';
    }
    if (!preferred) preferred = root.getAttribute('data-preferred-size') || '';
    preferred = normalizeSize(preferred);
    if (!preferred) preferred = '18ml';
    if (preferred && pills.length) {
      var match = null;
      pills.forEach(function (pill) {
        if (pill.disabled) return;
        if (normalizeSize(pill.getAttribute('data-size') || '') === preferred) match = pill;
      });
      if (!match) {
        pills.forEach(function (pill) {
          if (!match && !pill.disabled && pill.getAttribute('data-coming-soon') !== 'true') match = pill;
        });
      }
      if (match && !match.classList.contains('is-active')) match.click();
      else if (match) {
        filterGallery(preferred);
        syncSizeNote(match);
        syncComingSoonUi(match);
      }
    } else {
      var activePill = root.querySelector('[data-nb-pill].is-active') || pills[0];
      if (activePill) {
        syncSizeNote(activePill);
        syncComingSoonUi(activePill);
      }
    }

    if (qtyInput) {
      qtyInput.setAttribute('type', 'text');
      qtyInput.setAttribute('inputmode', 'numeric');
      qtyInput.setAttribute('pattern', '[0-9]*');
      if (!qtyInput.value) qtyInput.value = '1';
    }

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = String(Math.max(1, v - 1));
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = String(v + 1);
      });
    }

    form.addEventListener('submit', function onNbSubmit(e) {
      if (form.getAttribute('data-nb-native') === '1') return;
      e.preventDefault();
      e.stopPropagation();
      var activeSoon = root.querySelector('[data-nb-pill].is-active[data-coming-soon="true"]');
      var id = input && input.value;
      if (activeSoon || isComingSoonVariantId(id)) return;
      if (!id) return;
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = '<span>Adding…</span>';
      }
      addToCart(id, quantity)
        .then(function () {
          openDrawer();
        })
        .catch(function (err) {
          var msg = (err && err.message) || '';
          if (msg) window.alert(msg);
          // Never fall back to native submit for Coming Soon sizes
          if (/coming soon/i.test(msg) || isComingSoonVariantId(id)) return;
          form.setAttribute('data-nb-native', '1');
          HTMLFormElement.prototype.submit.call(form);
        })
        .finally(function () {
          if (!btn) return;
          var soonPill = root.querySelector('[data-nb-pill].is-active[data-coming-soon="true"]');
          if (soonPill || isComingSoonVariantId(input && input.value)) {
            btn.disabled = true;
            var label = btn.querySelector('[data-nb-atc-label]') || btn.querySelector('span');
            if (label) label.textContent = 'Coming Soon';
            return;
          }
          btn.disabled = false;
          btn.innerHTML = original;
        });
    });
  }

  function bindDrawer() {
    var root = drawer();
    if (!root || root.getAttribute('data-nb-drawer-bound') === '1') return;
    root.setAttribute('data-nb-drawer-bound', '1');

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-nb-drawer-close]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      var item = e.target.closest('.nb-drawer__item');
      if (!item) return;
      var line = parseInt(item.getAttribute('data-line'), 10);
      if (!line) return;

      if (e.target.closest('[data-nb-line-remove]')) {
        e.preventDefault();
        changeLine(line, 0).then(renderCart).catch(function () {});
        return;
      }

      var qtyInput = item.querySelector('[data-nb-line-qty]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      if (e.target.closest('[data-nb-line-minus]')) {
        e.preventDefault();
        changeLine(line, Math.max(0, qty - 1)).then(renderCart).catch(function () {});
      }
      if (e.target.closest('[data-nb-line-plus]')) {
        e.preventDefault();
        changeLine(line, qty + 1).then(renderCart).catch(function () {});
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closeDrawer();
    });
  }

  function applyCollectionSizeFromUrl() {
    try {
      var size = new URLSearchParams(window.location.search).get('size') || '18ml';
      var norm = String(size).toLowerCase().trim().replace(/\s+/g, '');
      if (norm === '15ml') norm = '18ml';
      size = norm;
      var isSoonSize = norm === '50ml' || norm === '100ml';

      document.querySelectorAll('[data-nb-size-filters] [data-filter-size]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-filter-size') === size);
      });

      document.querySelectorAll('[data-nb-card]').forEach(function (card) {
        var match = null;
        card.querySelectorAll('[data-nb-pill]').forEach(function (pill) {
          if (pill.disabled) return;
          var ps = String(pill.getAttribute('data-size') || '')
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '');
          if (ps === '15ml') ps = '18ml';
          if (ps === norm) match = pill;
        });
        if (!match) return;
        if (!match.classList.contains('is-active')) {
          match.click();
          return;
        }
        // Already active (e.g. after AJAX replace) — still sync price/image/variant + Coming Soon
        var input = card.querySelector('[data-nb-variant-input]');
        var priceEls = card.querySelectorAll('[data-nb-price]');
        var compareEl = card.querySelector('[data-nb-compare]');
        var cardMedia = card.querySelector('[data-nb-card-media]');
        var soonTag = card.querySelector('[data-nb-soon-tag]');
        var atcBtn = card.querySelector('[data-nb-atc]') || card.querySelector('button[type="submit"]');
        var atcLabel = card.querySelector('[data-nb-atc-label]');
        if (input) input.value = match.getAttribute('data-variant-id') || input.value;
        var nextPrice = match.getAttribute('data-price') || '';
        priceEls.forEach(function (priceEl) {
          priceEl.textContent = nextPrice;
        });
        var compare = match.getAttribute('data-compare') || '';
        if (compareEl) {
          if (compare) {
            compareEl.textContent = compare;
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        var imgUrl = match.getAttribute('data-image');
        if (cardMedia && imgUrl) {
          cardMedia.src = imgUrl;
          var srcset = match.getAttribute('data-image-srcset');
          if (srcset) cardMedia.srcset = srcset;
          var alt = match.getAttribute('data-image-alt');
          if (alt) cardMedia.alt = alt;
        }
        if (soonTag) {
          if (isSoonSize || match.getAttribute('data-coming-soon') === 'true') soonTag.removeAttribute('hidden');
          else soonTag.setAttribute('hidden', '');
        }
        if (atcBtn) {
          if (isSoonSize || match.getAttribute('data-coming-soon') === 'true') {
            atcBtn.disabled = true;
            if (atcLabel) atcLabel.textContent = 'Coming Soon';
          } else {
            atcBtn.disabled = match.disabled;
            if (atcLabel) atcLabel.textContent = match.disabled ? 'Sold Out' : 'Add to Cart';
          }
        }
      });
    } catch (err) {}
  }

  function boot() {
    bindDrawer();

    document.querySelectorAll('[data-nb-card], [data-nb-pdp], [data-nb-add-form]').forEach(function (el) {
      if (el.matches('[data-nb-add-form]') && el.closest('[data-nb-card], [data-nb-pdp]')) return;
      initRoot(el);
    });

    applyCollectionSizeFromUrl();

    document.querySelectorAll('[data-nb-cart-toggle]').forEach(function (btn) {
      if (btn.getAttribute('data-nb-cart-bound') === '1') return;
      btn.setAttribute('data-nb-cart-bound', '1');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    document.querySelectorAll('[data-nb-slider]').forEach(initSlider);
  }

  window.nbThemeBoot = boot;
  window.nbApplyCollectionSize = applyCollectionSizeFromUrl;

  function initSlider(root) {
    if (!root || root.getAttribute('data-nb-slider-bound') === '1') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-nb-slide]'));
    if (slides.length < 2) return;
    root.setAttribute('data-nb-slider-bound', '1');

    var dotsWrap = root.querySelector('[data-nb-slider-dots]');
    var index = Math.max(
      0,
      slides.findIndex(function (s) {
        return s.classList.contains('is-active');
      })
    );
    var timer = null;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function renderDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = slides
        .map(function (_, i) {
          return (
            '<button type="button" class="nb-home2-slider__dot' +
            (i === index ? ' is-active' : '') +
            '" data-nb-slider-goto="' +
            i +
            '" aria-label="Go to slide ' +
            (i + 1) +
            '"></button>'
          );
        })
        .join('');
    }

    function go(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle('is-active', on);
        if (on) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      renderDots();
    }

    function start() {
      if (reduceMotion) return;
      stop();
      timer = window.setInterval(function () {
        go(index + 1);
      }, 5500);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    root.querySelector('[data-nb-slider-prev]') &&
      root.querySelector('[data-nb-slider-prev]').addEventListener('click', function () {
        go(index - 1);
        start();
      });
    root.querySelector('[data-nb-slider-next]') &&
      root.querySelector('[data-nb-slider-next]').addEventListener('click', function () {
        go(index + 1);
        start();
      });
    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-nb-slider-goto]');
        if (!btn) return;
        go(parseInt(btn.getAttribute('data-nb-slider-goto'), 10) || 0);
        start();
      });
    }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    renderDots();
    go(index);
    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);

  // Wishlist — localStorage key shared with the theme wishlist page
  (function initWishlist() {
    var STORAGE_KEY = 'localWishlist';

    function readList() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        var list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
      } catch (err) {
        return [];
      }
    }

    function writeList(list) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    }

    function money(cents) {
      try {
        if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
          return Shopify.formatMoney(cents, theme.moneyFormat);
        }
      } catch (err) {}
      var n = (Number(cents) || 0) / 100;
      return 'Rs. ' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function syncUI() {
      var list = readList();
      document.querySelectorAll('[data-nb-wish]').forEach(function (btn) {
        var handle = btn.getAttribute('data-handle') || '';
        var on = handle && list.indexOf(handle) !== -1;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var titleEl = btn.closest('[data-nb-card], [data-nb-pdp]');
        var title = 'product';
        if (titleEl) {
          var t = titleEl.querySelector('.nb-card__title, .nb-pdp__title');
          if (t && t.textContent) title = t.textContent.trim();
        }
        btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add ' + title + ' to wishlist');
      });
      document.querySelectorAll('[data-nb-wish-count], .js-wishlist-count').forEach(function (el) {
        el.textContent = String(list.length);
        if (el.hasAttribute('data-nb-wish-count') || el.hasAttribute('hidden') || el.getAttribute('hidden') === '') {
          if (list.length > 0) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        }
      });
    }

    function renderGrid() {
      var grid = document.querySelector('[data-nb-wishlist-grid]');
      if (!grid) return;
      var list = readList();
      if (!list.length) {
        grid.innerHTML =
          '<div class="nb-wishlist-empty"><p class="nb-muted-alt">There are no products in your wishlist.</p></div>';
        return;
      }
      if (!grid.querySelector('.nb-wishlist-item')) {
        grid.innerHTML =
          '<div class="nb-wishlist-empty"><p class="nb-muted-alt">Loading your wishlist…</p></div>';
      }
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      Promise.all(
        list.map(function (handle) {
          return fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
            .then(function (r) {
              if (!r.ok) throw new Error('missing');
              return r.json();
            })
            .catch(function () {
              return null;
            });
        })
      ).then(function (products) {
        // Bail if list changed while fetching
        var current = readList().join(',');
        if (current !== list.join(',')) return;
        grid.innerHTML = '';
        var shown = 0;
        products.forEach(function (product) {
          if (!product) return;
          shown += 1;
          var card = document.createElement('article');
          card.className = 'nb-wishlist-item';
          card.setAttribute('data-handle', product.handle);
          var img = product.featured_image || '';
          var price = product.price_varies
            ? 'from ' + money(product.price_min)
            : money(product.price);
          card.innerHTML =
            '<a class="nb-wishlist-item__media" href="' +
            product.url +
            '">' +
            (img
              ? '<img src="' + img + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy">'
              : '') +
            '</a>' +
            '<div class="nb-wishlist-item__body">' +
            '<h3 class="nb-wishlist-item__title"><a href="' +
            product.url +
            '">' +
            product.title +
            '</a></h3>' +
            '<div class="nb-wishlist-item__price">' +
            price +
            '</div>' +
            '<button type="button" class="nb-wishlist-item__remove" data-nb-wish-remove data-handle="' +
            product.handle +
            '">Remove</button>' +
            '</div>';
          grid.appendChild(card);
        });
        if (!shown) {
          grid.innerHTML =
            '<div class="nb-wishlist-empty"><p class="nb-muted-alt">There are no products in your wishlist.</p></div>';
        }
      });
    }

    function toggle(handle) {
      if (!handle) return;
      var list = readList();
      var idx = list.indexOf(handle);
      if (idx === -1) list.push(handle);
      else list.splice(idx, 1);
      writeList(list);
      syncUI();
      if (document.querySelector('[data-nb-wishlist-grid]')) renderGrid();
    }

    document.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-nb-wish-remove]');
      if (remove) {
        e.preventDefault();
        toggle(remove.getAttribute('data-handle') || '');
        return;
      }
      var btn = e.target.closest('[data-nb-wish]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      toggle(btn.getAttribute('data-handle') || '');
    });

    function bootWish() {
      syncUI();
      renderGrid();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootWish);
    } else {
      bootWish();
    }
    document.addEventListener('shopify:section:load', bootWish);
    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY) bootWish();
    });
  })();

  // Character / partial-match product search (overlay + search page)
  (function initSearch() {
    var catalogPromise = null;
    var debounceTimer = null;
    var lastQuery = '';

    function root() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function moneyFromSuggest(price) {
      if (price == null || price === '') return '';
      var n = Number(price);
      if (isNaN(n)) return String(price);
      return 'Rs. ' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function moneyFromCents(cents) {
      var n = (Number(cents) || 0) / 100;
      return 'Rs. ' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function normalize(str) {
      return String(str || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    function compact(str) {
      return normalize(str).replace(/\s+/g, '');
    }

    // All query characters appear in order (e.g. "blue" ≈ "blu", "bhr" ≈ "bhairava")
    function sequentialMatch(hay, needle) {
      if (!needle) return true;
      var h = compact(hay);
      var n = compact(needle);
      var i = 0;
      for (var c = 0; c < h.length && i < n.length; c++) {
        if (h.charAt(c) === n.charAt(i)) i++;
      }
      return i === n.length;
    }

    function scoreProduct(product, query) {
      var q = normalize(query);
      if (!q || q.length < 1) return 0;
      var title = product.title || '';
      var handle = (product.handle || '').replace(/-/g, ' ');
      var tags = Array.isArray(product.tags) ? product.tags.join(' ') : String(product.tags || '');
      var type = product.type || product.product_type || '';
      var vendor = product.vendor || '';
      var hay = normalize([title, handle, tags, type, vendor].join(' '));
      var qc = compact(q);
      var tc = compact(title);
      var score = 0;

      if (normalize(title) === q) score += 200;
      if (tc.indexOf(qc) === 0) score += 120;
      if (tc.indexOf(qc) !== -1) score += 90;
      if (compact(handle).indexOf(qc) === 0) score += 85;
      if (compact(handle).indexOf(qc) !== -1) score += 55;
      if (hay.indexOf(q) !== -1) score += 40;
      if (sequentialMatch(title, q) && qc.length >= 3) score += 30;

      // Near-match on title words (blue→blu, hair→bhairava via prefix)
      normalize(title)
        .split(' ')
        .forEach(function (word) {
          var wc = compact(word);
          if (!wc) return;
          var shared = 0;
          while (shared < qc.length && shared < wc.length && qc.charAt(shared) === wc.charAt(shared)) shared++;
          if (shared >= 3 && Math.abs(wc.length - qc.length) <= 2) score += 95;
          else if (shared >= Math.min(3, qc.length) && shared >= qc.length - 1) score += 70;
          else if (shared >= 3 && shared / qc.length >= 0.6) score += 40;
          if (wc.indexOf(qc) !== -1 || (qc.indexOf(wc) !== -1 && wc.length >= 3)) score += 55;
        });

      return score;
    }

    function loadCatalog() {
      if (catalogPromise) return catalogPromise;
      catalogPromise = fetch(root() + 'products.json?limit=250')
        .then(function (r) {
          return r.ok ? r.json() : { products: [] };
        })
        .then(function (data) {
          return (data.products || []).map(function (p) {
            var img =
              (p.images && p.images[0] && (p.images[0].src || p.images[0])) ||
              (p.image && (p.image.src || p.image)) ||
              '';
            var minPrice = null;
            (p.variants || []).forEach(function (v) {
              var n = Number(v.price);
              if (!isNaN(n) && (minPrice === null || n < minPrice)) minPrice = n;
            });
            return {
              id: p.id,
              title: p.title,
              handle: p.handle,
              url: '/products/' + p.handle,
              tags: p.tags || [],
              type: p.product_type || '',
              vendor: p.vendor || '',
              image: img,
              price: minPrice != null ? minPrice : p.price,
              priceIsCents: false
            };
          });
        })
        .catch(function () {
          catalogPromise = null;
          return [];
        });
      return catalogPromise;
    }

    function fetchSuggest(query) {
      var params =
        'q=' +
        encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
      return fetch(root() + 'search/suggest.json?' + params)
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (data) {
          var list =
            (data &&
              data.resources &&
              data.resources.results &&
              data.resources.results.products) ||
            [];
          return list.map(function (p) {
            return {
              id: p.id,
              title: p.title,
              handle: p.handle,
              url: p.url ? p.url.split('?')[0] : '/products/' + p.handle,
              tags: p.tags || [],
              type: p.type || '',
              vendor: p.vendor || '',
              image: p.image || (p.featured_image && p.featured_image.url) || '',
              price: p.price_min || p.price,
              priceIsCents: false
            };
          });
        })
        .catch(function () {
          return [];
        });
    }

    function mergeResults(suggestList, catalogList, query) {
      var byHandle = {};
      function consider(p, boost) {
        var s = scoreProduct(p, query) + (boost || 0);
        if (s < 50) return;
        var existing = byHandle[p.handle];
        if (!existing || (existing._score || 0) < s) {
          byHandle[p.handle] = Object.assign({}, p, { _score: s });
        }
      }
      suggestList.forEach(function (p) {
        consider(p, 15);
      });
      catalogList.forEach(function (p) {
        consider(p, 0);
      });
      return Object.keys(byHandle)
        .map(function (h) {
          return byHandle[h];
        })
        .sort(function (a, b) {
          return (b._score || 0) - (a._score || 0);
        })
        .slice(0, 6);
    }

    function formatPrice(p) {
      if (p.price == null || p.price === '') return '';
      return p.priceIsCents ? moneyFromCents(p.price) : moneyFromSuggest(p.price);
    }

    function renderResults(container, products, query) {
      if (!container) return;
      if (!products.length) {
        container.innerHTML = '';
        container.hidden = true;
        return;
      }
      container.hidden = false;
      var html = products
        .map(function (p, idx) {
          var price = formatPrice(p);
          var meta = Array.isArray(p.tags) && p.tags.length ? p.tags.slice(0, 2).join(' · ') : p.type || '';
          return (
            '<a class="nb-search__item" role="option" href="' +
            p.url +
            '" data-index="' +
            idx +
            '">' +
            '<span class="nb-search__item-media">' +
            (p.image
              ? '<img src="' + p.image + '" alt="" loading="lazy" width="56" height="70">'
              : '') +
            '</span>' +
            '<span class="nb-search__item-copy">' +
            '<span class="nb-search__item-title">' +
            (p.title || '').replace(/</g, '&lt;') +
            '</span>' +
            (meta ? '<span class="nb-search__item-meta">' + meta.replace(/</g, '&lt;') + '</span>' : '') +
            '</span>' +
            (price ? '<span class="nb-search__item-price">' + price + '</span>' : '') +
            '</a>'
          );
        })
        .join('');
      html +=
        '<a class="nb-search__more" href="' +
        root() +
        'search?q=' +
        encodeURIComponent(query) +
        '&type=product&options%5Bprefix%5D=last">View all results</a>';
      container.innerHTML = html;
    }

    function setEmpty(scope, show) {
      var empty = scope.querySelector('[data-nb-search-empty]');
      var hint = scope.querySelector('[data-nb-search-hint]');
      if (empty) empty.hidden = !show;
      if (hint) hint.hidden = show || (scope.querySelector('[data-nb-search-input]') || {}).value;
    }

    function runQuery(scope, query) {
      var input = scope.querySelector('[data-nb-search-input]');
      var results = scope.querySelector('[data-nb-search-results]');
      var clearBtn = scope.querySelector('[data-nb-search-clear]');
      var q = (query || '').trim();
      if (clearBtn) clearBtn.hidden = !q;
      if (input) input.setAttribute('aria-expanded', q ? 'true' : 'false');

      if (q.length < 1) {
        renderResults(results, [], '');
        setEmpty(scope, false);
        var hint = scope.querySelector('[data-nb-search-hint]');
        if (hint) hint.hidden = false;
        var server = scope.querySelector('[data-nb-search-server]');
        if (server) server.hidden = false;
        return;
      }

      var hintEl = scope.querySelector('[data-nb-search-hint]');
      if (hintEl) hintEl.hidden = true;
      var serverEl = scope.querySelector('[data-nb-search-server]');
      if (serverEl) serverEl.hidden = true;

      Promise.all([fetchSuggest(q), loadCatalog()]).then(function (pair) {
        if ((input && input.value.trim()) !== q) return;
        var merged = mergeResults(pair[0], pair[1], q);
        renderResults(results, merged, q);
        setEmpty(scope, merged.length === 0);
      });
    }

    function schedule(scope, query) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        lastQuery = query;
        runQuery(scope, query);
      }, 160);
    }

    function openSearch() {
      var panel = document.querySelector('[data-nb-search]');
      if (!panel) return;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('nb-search-open');
      loadCatalog();
      var input = panel.querySelector('[data-nb-search-input]');
      if (input) {
        setTimeout(function () {
          input.focus();
          if (input.value) runQuery(panel, input.value);
        }, 50);
      }
    }

    function closeSearch() {
      var panel = document.querySelector('[data-nb-search]');
      if (!panel) return;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('nb-search-open');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-nb-search-open]')) {
        e.preventDefault();
        openSearch();
        return;
      }
      if (e.target.closest('[data-nb-search-close]')) {
        e.preventDefault();
        closeSearch();
        return;
      }
      if (e.target.closest('[data-nb-search-clear]')) {
        e.preventDefault();
        var scope = e.target.closest('[data-nb-search]') || e.target.closest('[data-nb-search-page]');
        var input = scope && scope.querySelector('[data-nb-search-input]');
        if (input) {
          input.value = '';
          input.focus();
          runQuery(scope, '');
        }
      }
    });

    document.addEventListener('input', function (e) {
      var input = e.target.closest('[data-nb-search-input]');
      if (!input) return;
      var scope = input.closest('[data-nb-search]') || input.closest('[data-nb-search-page]') || document;
      schedule(scope, input.value);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch();
    });

    // Live results on dedicated search page (including initial query)
    var page = document.querySelector('[data-nb-search-page]');
    if (page) {
      var pageInput = page.querySelector('[data-nb-search-input]');
      if (pageInput && pageInput.value.trim()) {
        runQuery(page, pageInput.value);
      }
    }
  })();

  // Footer newsletter — thank-you after Shopify customer form redirect
  (function initNewsletter() {
    var THANKS = 'Thank You for subscribing to Nibhas offers and lucrative deals.';

    function showSuccess(root) {
      if (!root) return;
      var fields = root.querySelector('[data-nb-newsletter-fields]');
      var success = root.querySelector('[data-nb-newsletter-success]');
      var error = root.querySelector('[data-nb-newsletter-error]');
      var note = root.querySelector('.nb-footer__note');
      if (fields) fields.hidden = true;
      if (note) note.hidden = true;
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }
      if (success) {
        success.hidden = false;
        success.removeAttribute('hidden');
        success.textContent = THANKS;
      }
      try {
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (err) {}
    }

    try {
      var params = new URLSearchParams(window.location.search);
      if (
        params.get('customer_posted') === 'true' ||
        params.get('contact_posted') === 'true' ||
        window.location.hash === '#NbNewsletter'
      ) {
        // Only treat hash alone as success when query confirms post
        if (
          params.get('customer_posted') === 'true' ||
          params.get('contact_posted') === 'true'
        ) {
          var postedRoot = document.querySelector('[data-nb-newsletter]');
          if (postedRoot) showSuccess(postedRoot);
        }
      }
    } catch (err) {}
  })();
})();
